import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  type = "website",
  structuredData,
}) => {
  const siteName = "SeaPulse Albania";
  const defaultTitle =
    "SeaPulse Albania | Boat Tours Durrës – Speedboat, Yacht & Jet Ski";
  const defaultDescription =
    "Book boat tours in Durrës, Albania from €50/person with SeaPulse. Speedboat adventures, luxury yachts, jet ski rentals & secret beach escapes. Professional crew, instant online booking.";
  const defaultKeywords =
    "boat tours Durrës Albania, Albania boat tours, speedboat tour Albania, boat cruise Durrës, sea tours Albania, luxury yachts Albania, jet ski Durrës, Albanian coast tours, boat rental Albania, water sports Durrës";
  const siteUrl = "https://seapulsealbania.com";
  const defaultImage = `${siteUrl}/logo-light-bg.png`;

  const fullTitle = title
    ? title.includes("SeaPulse")
      ? title
      : `${title} | ${siteName}`
    : defaultTitle;
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || defaultKeywords;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const imageUrl = ogImage || defaultImage;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={imageUrl} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
